import { Amplify } from 'aws-amplify';

/**
 * Amplify-Konfiguration.
 *
 * `amplify_outputs.json` entsteht beim Sandbox- oder Pipeline-Deploy und ist
 * bewusst nicht eingecheckt. Ohne die Datei startet die App trotzdem — sie
 * zeigt dann einen verständlichen Hinweis statt eines Stacktrace.
 */

export interface UepAusgaben {
  custom?: {
    region?: string;
    downloadEndpunkt?: string;
    dateiBucket?: string;
  };
  [schluessel: string]: unknown;
}

let konfiguriert = false;
let ausgaben: UepAusgaben | null = null;

const istPlatzhalter = (kandidat: UepAusgaben): boolean =>
  (kandidat as { __platzhalter?: boolean }).__platzhalter === true;

export const amplifyKonfigurieren = async (): Promise<boolean> => {
  if (konfiguriert) return true;
  try {
    const modul = (await import('#amplify-outputs')) as { default: unknown };
    const kandidat = modul.default as UepAusgaben;
    if (istPlatzhalter(kandidat)) return false;
    ausgaben = kandidat;
    Amplify.configure(ausgaben as Parameters<typeof Amplify.configure>[0]);
    konfiguriert = true;
    return true;
  } catch {
    // Die Datei fehlt nur vor dem ersten Deploy. Das ist ein
    // Einrichtungsproblem, kein Laufzeitfehler.
    return false;
  }
};

export const istKonfiguriert = (): boolean => konfiguriert;

export const backendAusgaben = (): UepAusgaben | null => ausgaben;

/** Basis-URL des öffentlichen Download-Endpunkts. */
export const downloadEndpunkt = (): string => ausgaben?.custom?.downloadEndpunkt ?? '';

/**
 * Vollständige Adresse des öffentlichen Downloads zu einem Token.
 *
 * Die Mail nennt die eigene Domain (`…/protokoll/{token}`), erreichbar ist der
 * Endpunkt aber unter der Function-URL. Diese Funktion setzt beides zusammen;
 * `/protokoll/{token}` ist der Pfad, den die Lambda erwartet.
 *
 * Leer, wenn Token oder Endpunkt fehlen — die Seite zeigt dann einen Hinweis
 * statt einer kaputten Adresse.
 */
export const downloadZielUrl = (endpunkt: string, token: string): string => {
  const basis = endpunkt.trim().replace(/\/+$/, '');
  if (basis === '' || token.trim() === '') return '';
  return `${basis}/protokoll/${encodeURIComponent(token.trim())}`;
};
